import UEapi from '../UEapi/UEapi'
import Store from '../../store'
import ObjectManager from './ObjectManager'
import OverlayTip from '@/utils/UEapi/OverlayTip'
import panelControl from '@/utils/configs/panelControl'
import HJJCSB from '@/components/UE4Panel/HJJCSB'
import KT from '@/components/UE4Panel/KT'
import UPS from '@/components/UE4Panel/UPS'
import PDG from '@/components/UE4Panel/PDG'
import SBSB from '@/components/UE4Panel/SBSB'
import DBSB from '@/components/UE4Panel/DBSB'
import RQBSB from '@/components/UE4Panel/RQBSB'
import {
  getName
} from '../common/commonHelper'

export default class MapLayerContral {
  static panelArr = []
  static panelID = ''
  static coordZ = 0
  static PanelSetting = {
    '园区-环境监测设备': {
      com: HJJCSB,
      size: [330, 270],
      offset: [-100, -60], //0.8
    },
    '园区-空调': {
      com: KT,
      size: [630, 310],
      //offset: [-160, -80], //0.5
      // offset: [-60, -40], //4k
      offset: [-190, -68], //2k
    },
    '园区-UPS': {
      com: UPS,
      size: [350, 200],
      // offset: [10, -40], //4k
      offset: [-65, -5], //2k
    },
    '园区-配电柜': {
      com: PDG,
      size: [350, 200],
      // offset: [10, -40], //4k
      offset: [-65, -5], //2k
    },
    '园区-水表设备': {
      com: SBSB,
      size: [350, 200],
      // offset: [10, -40], //4k
      offset: [-65, -5], //2k

    },
    '园区-电表设备': {
      com: DBSB,
      size: [350, 200],
      // offset: [10, -40], //4k
      offset: [-65, -5], //2k

    },
    '园区-燃气表设备': {
      com: RQBSB,
      size: [350, 200],
      // offset: [10, -40], //4k
      offset: [-65, -5], //2k
    },
  }
  static layerContral(ele) {
    let {
      spaceLevel,
      floor
    } = Store.state
    this.coordZ = ObjectManager.levelMapper[spaceLevel]
    if (!this.coordZ) {
      this.coordZ = ObjectManager.levelMapper['楼层_F' + floor]
    }
    // 不规则名字修改
    let names = {
      '摄像头(固定)': '摄像头固定',
      '摄像头(云台)': '摄像头云台',
      '摄像头(人脸识别)': '摄像头人脸识别',
    }
    let id = names[ele.text] || ele.text
    if (ele.highlight) {
      let allList = JSON.parse(window.sessionStorage.getItem('allList'))
      let points = allList[id]
      let type = '楼层_地下室'
      if (spaceLevel == '楼层_默认') {
        if (floor == 1) {
          type = '楼层_大厅'
        } else if (floor > 1) {
          type = '楼层_F' + floor
        }
      } else {
        type = spaceLevel
      }
      let data = []
      if (points) {
        data = points.data.filter((item) => {
          return item.type == type
        })
      }

      switch (ele.overlayType) {
        case 'landmarkLayer':
          this.addLandmarkLayer(id, data)
          break
        case 'heatMapLayer':
          this.addHeatMapLayer(id, data)
          break
        case 'typeAreaLayer':
          this.addTypeAreaLayer(id, data)
          break
        case 'trailLayer':
          this.addTrailLayer(id, data)
          break
        case 'eventLayer':
          this.addBubberLayer('气泡' + id, data)
          this.addLandmarkBubberLayer('气泡地标' + id, data)
          break
        case 'path':
          this.addPath(id, data)
          break
        case 'trackLayer':
          this.addTrackLayer(id, data)
          break
        case 'floor':
          this.showPowerWraper(ele.text)
          break
        case 'room':
          this.showRooms(true)
          break
        case '3DMarker':
          this.add3DMarker(id, data)
          break
        case 'panel':
          this.addLandmarkPanel(id, data)
          break
        default:
          break
      }
    } else {
      if (ele.overlayType == 'trailLayer') {
        UEapi.TrailLayer.clearTrailLayerTimers(id)
      }
      if (ele.overlayType == 'floor') {
        this.showPowerWraper(false)
      }
      if (ele.overlayType == 'eventLayer') {
        UEapi.Common.removeOverlay({
          id: '气泡' + id,
          overlayType: 'bubbleLayer',
        })
        UEapi.Common.removeOverlay({
          id: '气泡地标' + id,
          overlayType: 'landmarkLayer',
        })
        return
      }
      if (ele.overlayType === 'trackLayer') {
        appInstance.uniCall('clearOverlayType', {
          overlayType: 'trackLayer', // 图层对象类别
        })
        return
        let allList = JSON.parse(window.sessionStorage.getItem('allList'))
        let points = allList[id]
        let type = '楼层_地下室'
        if (spaceLevel == '楼层_默认') {
          if (floor == 1) {
            type = '楼层_大厅'
          } else if (floor > 1) {
            type = '楼层_F' + floor
          }
        } else {
          type = spaceLevel
        }
        let data = points.data.filter((item) => {
          return item.type == type
        })
        data.forEach((pointLayer) => {
          UEapi.Common.removeOverlay({
            id: pointLayer.id,
            overlayType: 'trackLayer',
          })
        })
      }
      if (ele.overlayType === 'path') {
        let allList = JSON.parse(window.sessionStorage.getItem('allList'))
        let points = allList[id]
        let type = '楼层_地下室'
        if (spaceLevel == '楼层_默认') {
          if (floor == 1) {
            type = '楼层_大厅'
          } else if (floor > 1) {
            type = '楼层_F' + floor
          }
        } else {
          type = spaceLevel
        }
        let data = points.data.filter((item) => {
          return item.type == type
        })
        data.forEach((pointLayer) => {
          UEapi.Common.removeOverlay({
            id: pointLayer.id,
            overlayType: 'path',
          })

          UEapi.Common.removeOverlay({
            id: pointLayer.id,
            overlayType: 'landmarkLayer',
          })
        })
      }
      if (ele.overlayType == 'room') {
        this.showRooms(false)
      }
      if (ele.overlayType == 'panel') {
        this.panelArr.forEach((item) => {
          if (item.id == ele.text) {
            this.removeOverLayTip(item)
          }
        })
        return
      }
      UEapi.Common.removeOverlay({
        id: id,
        overlayType: ele.overlayType || 'landmarkLayer' || 'panel',
      })
    }
  }

  static addLandmarkLayer(id, data) {
    let jsonData = {
      id: id,
      name: id,
      legends: [{
        name: 'default',
        color: '#ff0000',
        iconName: 'custom-' + id,
      }, ],
      data: data.map((item) => {
        return {
          id: item.id,
          label: '',
          coord: [item.lon, item.lat],
          coordZ: this.coordZ,
          type: 'default',
        }
      }),
    }
    UEapi.landmarkLayer.addLandmarkLayer(jsonData)
  }

  static addHeatMapLayer(id, points) {
    let styles = {
      valueMax: 100,
      valueMin: 0,
      radius: 8,
    }
    if (Store.state.spaceLevel == '园区') {
      styles = {
        valueMax: 200,
        valueMin: 0,
        radius: 20,
      }
    }
    let jsonData = {
      id: id,
      name: id,
      coordType: 0,
      coordTypeZ: 0,
      coordZ: this.coordZ,
      type: 'default',
      alpha: 0.8,
      colorMax: '#ff0000',
      colorMin: '#0000ff',
      valueMax: styles.valueMax,
      valueMin: styles.valueMin,
      radius: styles.radius,
      visible: true,
      pointDataId: '',
      data: points.map((item) => {
        return {
          coord: [item.lon, item.lat],
          value: item.value,
        }
      }),
    }
    UEapi.HeatMapLayer.addHeatMapLayer(jsonData)
  }

  static addTypeAreaLayer(id, points) {
    let jsonData = {
      id: id,
      name: id,
      coordType: 0,
      coordTypeZ: 0,
      coordZ: this.coordZ,
      alpha: 0.3,
      visible: true,
      lineDataId: '',
      // 可以有多个区域
      areas: points.map((item) => {
        return {
          name: item.id,
          points: item.points.map((point) => {
            return {
              coord: point,
            }
          }),
        }
      }),
      legends: [
        // 可以有多个图例
        {
          name: 'legendName1',
          type: 'Grid05',
          color: '#189BFA',
          areaHeight: 20,
          fillArea: 'Segment01',
          fillPosition: 'none',
        },
      ],
      // 可以有多个对应关系
      data: points.map((item) => {
        return {
          areaName: item.id,
          legendName: 'legendName1',
        }
      }),
    }
    UEapi.TypeAreaLayer.addTypeAreaLayer(jsonData)
  }

  static addTrailLayer(id, points) {
    const coordZ = ObjectManager.getCoordZ()
    let children = []
    let dataSet = {}
    points &&
      points.forEach((item) => {
        // 给相同数据起个名字
        let name = ObjectManager.nameSet[item.name]
        if (!name) {
          ObjectManager.nameSet[item.name] = getName()
          name = ObjectManager.nameSet[item.name]
        }

        if (dataSet[name]) {
          dataSet[name].push({
            label: name,
            ...item,
          })
        } else {
          dataSet[name] = []
          dataSet[name].push({
            label: name,
            ...item,
          })
        }
      })

    for (let name in dataSet) {
      children.push({
        id: dataSet[name][0].name, // 用原数据的唯一name
        label: name, // 给原数据唯一name起的姓名
        num: '',
        data: dataSet[name],
      })
    }

    // 判断是否有子元素 可以添加图层
    if (children.length > 0) {
      let data = children.map((child) => {
        return {
          id: child.id,
          label: '',
          coord: [child.data[0].lon, child.data[0].lat],
          coordZ: coordZ,
          type: child.id,
        }
      })
      let legends = children.map((child) => {
        return {
          name: child.id,
          iconName: `custom-${id}`,
          trackColor: '#ff0000',
        }
      })
      let params = {
        id: id,
        name: id,
        coordType: 0,
        coordTypeZ: 0,
        trackStyle: 'style001',
        trackDuration: 10,
        objLife: 10,
        trackWidth: 0.1 * 133, // *133
        duraiotn: 1,
        visible: true,
        legends: legends,
        data: data,
      }
      UEapi.TrailLayer.addTrailLayer(params, () => {
        UEapi.TrailLayer.updateData(params, children, coordZ)
      })
    }
  }
  static addLandmarkBubberLayer(id, data) {
    let jsonData = {
      id: id,
      name: id,
      legends: [{
        name: 'default',
        color: '#ff0000',
        iconName: 'custom-alert',
      }, ],
      data: data.map((item) => {
        return {
          id: item.id,
          label: '',
          coord: [item.lon, item.lat],
          coordZ: item.coordZ || this.coordZ,
          type: 'default',
        }
      }),
    }
    UEapi.landmarkLayer.addLandmarkLayer(jsonData)
  }

  static addBubberLayer(id, data) {
    let {
      spaceLevel,
      floor
    } = Store.state
    let jsonData = {
      id: id,
      name: id,
      speed: spaceLevel == '园区' ? 10 : 5,
      radiusMax: spaceLevel == '园区' ? 300 : 10,
      radiusMin: spaceLevel == '园区' ? 20 : 5,
      valueMax: spaceLevel == '园区' ? 800 : 10,
      valueMin: spaceLevel == '园区' ? 50 : 5,
      visible: true,
      legends: [{
        name: 'default',
        color: '#ff0000',
      }, ],
      data: data.map((item) => {
        return {
          id: item.id,
          label: '',
          coord: [item.lon, item.lat],
          coordZ: item.coordZ || this.coordZ,
          type: 'default',
        }
      }),
    }
    UEapi.Bubble.addBubbleLayer(jsonData)
  }

  static addPathPoints(id, data) {
    data.forEach((pointsLayer) => {
      let jsonData = {
        id: pointsLayer.id,
        name: pointsLayer.id,
        legends: [{
          name: 'default',
          color: '#ff0000',
          iconName: 'custom-' + id,
        }, ],
        data: [pointsLayer.points[0], pointsLayer.points.at(-1)].map((item) => {
          return {
            id: item.pid,
            label: '',
            coord: item.coord,
            coordZ: this.coordZ,
            type: 'default',
          }
        }),
      }
      UEapi.landmarkLayer.addLandmarkLayer(jsonData)
    })
  }
  static addTrackLayer(id, data) {
    data.forEach((pointsLayer) => {
      let jsonData = {
        id: pointsLayer.id,
        name: pointsLayer.id,
        legends: pointsLayer.points.map((item, index) => {
          return {
            name: item.pid,
            color: '#ff0000',
            icon: 'custom-' + id,
            // icon: 'camera',
            lineColor: '#00ff00',
            lineWidth: 2,
            lineType: 'arrow', //default 波浪线型, arrow 箭头型, dot 虚线型, ray 射线型
            lineSpeed: 1,
            curvature: 0.5,
          }
        }),
        data: pointsLayer.points.map((item, index) => {
          return {
            id: pointsLayer.id,
            label: '',
            coord: item.coord,
            coordZ: this.coordZ,
            type: item.pid,
            time: '2021-07-22 19:45:5' + index,
          }
        }),
      }
      UEapi.TrackLayer.addTrackLayer(jsonData)
    })
  }
  static showPowerWraper(flag) {
    let floors = [
      'building01_floor1_boxpower1',
      'building01_floor2_boxpower2',
      'building01_floor3_boxpower3',
      'building01_floor4_boxpower4',
      'building01_floor5_boxpower5',
      'building01_floor6_boxpower6',
      'building01_floor7_boxpower7',
      'building01_floor8_boxpower8',
      'building01_floor9_boxpower9',
      'building01_floor10_boxpower10',
      'building01_floor11_boxpower11',
      'building01_floor12_boxpower12',
      'building01_floor13_boxpower13',
      'building01_floor14_boxpower14',
    ]
    let colorList = {
      楼层用水量: ['#003A75', '#007ECA', '#26C9FF'],
      楼层用电量: ['#6A2800', '#EA6900', '#FF952B'],
      楼层供暖量: ['#B20000', '#D90000', '#FF2626'],
    }
    if (flag == false) {
      UEapi.Model.setModelVisibility({
        ids: floors,
        visible: false,
      })
    } else {
      UEapi.Model.setModelVisibility({
        ids: floors,
        visible: true,
      })
      floors.forEach((item, index) => {
        let i = parseInt(Math.random() * 3)
        UEapi.Model.setModelVisible({
          id: item,
          alpha: 0.7,
          scale: 1,
          maskType: 'color',
          maskAlpha: 0.8,
          maskColor: colorList[flag][i],
          maskPicture: '',
          maskPictureScale: 1.0,
          maskFlowSpeed: 1.0,
          maskFlowDirection: 90,
          includeChildren: 'false',
          xRay: 'off',
        })
      })
    }
  }
  static showRooms(flag = true) {
    let ids = [
      'building01_floor6_room1_corridor1',
      'building01_floor6_room2_corridor2',
      'building01_floor6_room3_corridor3',
      'building01_floor6_room4_lift4',
      'building01_floor6_room5_lift5',
      'building01_floor6_room6_lift6',
      'building01_floor6_room7_lift7',
      'building01_floor6_room8_lift8',
      'building01_floor6_room9_stair9',
      'building01_floor6_room10_stair10',
      'building01_floor6_room11_stair11',
      'building01_floor6_room12_stair12',
      'building01_floor6_room13_exit13',
      'building01_floor6_room14_exit14',
      'building01_floor6_room15_exit15',
      'building01_floor6_room16_exit16',
      'building01_floor6_room17_exit17',
      'building01_floor6_room18_exit18',
      'building01_floor6_room19_exit19',
      'building01_floor6_room20_exit20',
      'building01_floor6_room21_exit21',
      'building01_floor6_room22_exit22',
      'building01_floor6_room23_exit23',
      'building01_floor6_room24_exit24',
      'building01_floor6_room25_exit25',
      'building01_floor6_room26_exit26',
      'building01_floor6_room27_exit27',
      'building01_floor6_room28_exit28',
      'building01_floor6_room29_exit29',
      'building01_floor6_room30_exit30',
      'building01_floor6_room31_exit31',
      'building01_floor6_room32_exit32',
      'building01_floor6_room33_exit33',
      'building01_floor6_room34_exit34',
      'building01_floor6_room35_exit35',
      'building01_floor6_room36_exit36',
      'building01_floor6_room37_Office37',
      'building01_floor6_room38_Office38',
      'building01_floor6_room39_Office39',
      'building01_floor6_room40_Office40',
      'building01_floor6_room41_Office41',
      'building01_floor6_room42_Office42',
      'building01_floor6_room43_Office43',
      'building01_floor6_room44_Office44',
      'building01_floor6_room45_Office45',
      'building01_floor6_room46_Office46',
      'building01_floor6_room47_Office47',
      'building01_floor6_room48_Office48',
      'building01_floor6_room49_Office49',
      'building01_floor6_room50_Office50',
      'building01_floor6_room51_Office51',
      'building01_floor6_room52_Office52',
      'building01_floor6_room53_Office53',
      'building01_floor6_room54_Office54',
      'building01_floor6_room55_Office55',
      'building01_floor6_room56_Office56',
      'building01_floor6_room57_Office57',
      'building01_floor6_room58_Office58',
      'building01_floor6_room59_Office59',
      'building01_floor6_room60_Office60',
      'building01_floor6_room61_Office61',
      'building01_floor6_room62_Office62',
      'building01_floor6_room63_Office63',
      'building01_floor6_room64_Office64',
      'building01_floor6_room65_Office65',
      'building01_floor6_room66_Office66',
      'building01_floor6_room67_Office67',
      'building01_floor6_room68_Office68',
      'building01_floor6_room69_Office69',
      'building01_floor6_room70_Office70',
      'building01_floor6_room71_Office71',
      'building01_floor6_room72_Office72',
      'building01_floor6_room73_Office73',
      'building01_floor6_room74_Office74',
    ]
    if (typeof flag == 'boolean') {
      UEapi.Model.setModelVisibility({
        ids: ids,
        visible: flag,
      })
    } else {
      UEapi.Model.setModelVisibility({
        ids: ids,
        visible: false,
      })
      UEapi.Model.setModelVisibility({
        ids: [flag],
        visible: true,
      })
    }
  }
  static add3DMarker(id, data) {
    data.forEach((item) => {
      let params = {
        id: item.name,
        coordType: 0,
        coordTypeZ: 0,
        alpha: 1,
        scale: 1,
        type: item.markerType,
        titleText: '',
        titleColor: '#ffffff',
        titleBackgroundColor: '#333333',
        tag: 'custominfo',
        coord: [item.lon, item.lat],
        coordZ: item.coordZ,
        visible: true,
      }
      UEapi.Marker3D.add3DMarker(params)
    })
  }
  static addLandmarkPanel(id, data) {
    let that = this
    let jsonData = {
      id: id,
      name: id,
      legends: [{
        name: 'default',
        color: '#ff0000',
        iconName: 'custom-' + id,
      }, ],
      data: data.map((item) => {
        return {
          id: item.id,
          label: '',
          coord: [item.lon, item.lat],
          coordZ: this.coordZ,
          type: 'default',
        }
      }),
    }
    UEapi.landmarkLayer.addLandmarkLayer(jsonData)
    setTimeout(() => {
      that.addpanel(id, jsonData.data)
    }, 1000)
  }
  static addpanel(id, data) {
    data.forEach((p, index) => {
      let ele = null
      ele = panelControl.create(p.id, this.PanelSetting[id].com, p, 1)
      appInstance.uniCall(
        'addOverlayTip', {
          id: p.id,
          url: '',
          size: [ele.clientWidth, ele.clientHeight],
          offset: this.PanelSetting[id].offset || [-1000, -1000],
          overlayType: 'landmarkLayer',
          isShowClose: false,
          divId: ele.id,
        },
        (tip) => {
          this.panelArr.push({
            id: id,
            value: p.id,
          })
          console.log('添加标牌', ele, tip, 'maplayer')
        }
      )
    })
  }
  static showRoomsComfort(callback) {
    let timer = setTimeout(function () {
      MapLayerContral.layerContral({
        text: '6层房间散点',
        highlight: true,
        overlayType: 'landmarkLayer',
      })
      MapLayerContral.layerContral({
        text: '房间舒适度',
        highlight: true,
        overlayType: 'room',
      })
      callback && callback()
      clearTimeout(timer)
    }, 1400)
  }
  static removeOverLayTip(p) {
    window.appInstance.uniCall('removeOverlayTip', {
      id: p.value,
      overlayType: 'landmarkLayer',
    })
    window.appInstance.uniCall('removeOverlay', {
      id: p.id,
      overlayType: 'landmarkLayer',
    })
    let ids = document.getElementById(p.value)
    ids?.remove()
  }
}